"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CmsPageDataEditor = /** @class */ (function (_super) {
    __extends(CmsPageDataEditor, _super);
    function CmsPageDataEditor(props) {
        return _super.call(this, props) || this;
    }
    CmsPageDataEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                tag: this.props.record.page_tag,
                description: this.props.record.description,
                brand_id: this.props.record.brand_id,
                brand_title: this.props.record.brand_title
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Редактирование страницы"]);
            });
        }
        else {
            this.setState({
                title: "",
                tag: "",
                description: "",
                brand_id: -1,
                brand_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание страницы"]);
            });
        }
        this.doReSetRules();
    };
    CmsPageDataEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            tag_rules: { isError: false },
            brand_rules: { isError: false },
        });
    };
    CmsPageDataEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                title: this.state.title,
                page_tag: this.state.tag,
                description: this.state.description,
                key: this.props.record.key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страница изменена!");
            });
        }
    };
    CmsPageDataEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.tag) || (this.state.tag.length === 0)) {
            this.setState({ tag_rules: { isError: true, errorMessage: "Поле [tag] не заполнено!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" }
            });
            return false;
        }
        return true;
    };
    CmsPageDataEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                page_tag: this.state.tag,
                description: this.state.description,
                brand_id: this.state.brand_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Страница добавлена!");
            });
        }
    };
    CmsPageDataEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CmsPageDataEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить страницу";
        }
        else {
            return "Изменить страницу";
        }
    };
    CmsPageDataEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false },
                    });
                }, items: this.props.brandsList, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг:", placeholder: "Введите тэг" }, value: this.state.tag, onValueChanged: function (newVal) {
                    _this.setState({
                        tag: newVal,
                        tag_rules: { isError: false }
                    });
                }, required: true, rules: this.state.tag_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CmsPageDataEditor;
}(React.Component));
exports.default = CmsPageDataEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_pages/ui/component/CmsPageDataEditor.tsx
// module id = 2399
// module chunks = 0